define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const BaseView = require('../../../base.view');
    const Model = require('backbone').Model;
    const getDynamicTagValue = require('../../../../util/swiss-theme/dynamicTag.value.util');
    require('../../../../widgets/autocomplete.widget');

    module.exports = BaseView.extend({
        options: {
            template: 'customEmail',
            label: '',
            placeholder: '',
            active: true,
            isDefaultResult: true,
            elSelector: '.fn-email-input-text'
        },

        events: {
            'focusin .fn-email-input-text': 'setDropDownResult',
            'focusout .fn-email-input-text': 'addNextElementFocus'
        },

        initialize: function(options) {
            this.options.form = options.form;
            this.model = new Model();
            this.getDomains();
        },

        getDomains: function() {
            const domains = getDynamicTagValue('DOMAINS');
            if (!domains || (!domains.includes('default=') && !domains.includes('hidden='))) {
                console.error(`Dynamic Tag DTAG_DOMAINS doesn't exist or data format ${domains} is invalid`);
                this.options.defaultDomains = [];
                this.options.hiddenDomains = [];

                return ;
            }
            const arrayFromTag = domains?.split(';');
            const domainsArray = arrayFromTag && arrayFromTag.reduce((acc, curr) => {
                const r = curr.split('=');
                const o = r[1].split(',');

                curr = r[0];
                acc[curr] = {
                    domains: o
                };
                return acc;
            }, {});

            this.options.defaultDomains = domainsArray.default?.domains || [];
            this.options.hiddenDomains = domainsArray.hidden?.domains || [];
        },

        setDropDownResult: function() {
            this.searchText = '';
            this.model.set({ isHidden: true, searchResult: [] });
            this.$(this.options.elSelector).autocomplete('setResult', []);
        },

        search: function(value) {
            const at = '@';
            const indexOfAt = value.indexOf(at);

            if (value.includes(at)) {
                const getDomainsArray = array => array.map((e, ind) => value.slice(0, indexOfAt + 1) + array[ind]);
                const clearedValue = value.slice(indexOfAt, value.length);
                const defaultDomainsArray = getDomainsArray(this.options.defaultDomains);
                const hiddenDomainsArray = getDomainsArray(this.options.hiddenDomains);

                   if (clearedValue === at) {
                       const result = this.options.defaultDomains.map((e, ind)=>
                           value + this.options.defaultDomains[ind]);
                       this.showDropDown(result);
                   } else {
                       const getDomains = array => array.filter(ele => ele.startsWith(value));
                       const defaultDomains = getDomains(defaultDomainsArray);
                       const hiddenDomains = getDomains(hiddenDomainsArray);
                       const result = _.union(defaultDomains, hiddenDomains);
                       this.showDropDown(result);
                   }
            } else {
                this.hideDropDown();
            }
        },

        showDropDown: function(cached) {
            this.model.set({ searchResult: cached });

            if (Array.isArray(cached)) {
                cached = cached.map((item) => this.formatOutput(item));
            }

            this.$(this.options.elSelector).autocomplete('setResult', cached);
        },

        formatOutput: function(value) {
            const text = value;
            const regexp = function() {
                return new RegExp(/@(.*)/i);
            };
            const highlight = function(str, re) {
                return str ? str.replace(re, '<span class="highlight">@$1</span>') : null;
            };

            if (Array.isArray(this.searchText)) {
                return this.searchText.map(regexp).reduce(highlight, text);
            }

            if (typeof this.searchText === 'string') {
                return highlight(text, regexp());
            }

            return text;
        },

        hideDropDown: function() {
            this.model.set({ isHidden: true, searchResult: [] });
            document.querySelector(this.options.elSelector) && this.$(this.options.elSelector).autocomplete('setResult', []);
        },

        handleSelectItem: function(value) {
            const selectedItem = this.model.get('searchResult')[value];
            this.el.querySelector('input.fn-email-input-text').value = selectedItem ? selectedItem : '';
            selectedItem && this.options.form.validateField(this.$el.find('.fn-validate'));
            this.options.form.data();
        },

        addNextElementFocus: function() {
            this.hideDropDown();
            this.options.form.validateField(this.$el.find('.fn-validate'));
            if (this.el.nextElementSibling && this.el.nextElementSibling?.querySelector('input')) {
                const input = this.el.nextElementSibling?.querySelector('input');
                const notFocusedInputFields = ['radio', 'hidden', 'checkbox'];
                if (!notFocusedInputFields.includes(input.type)) {
                    const end = input.value.length;

                    input.setSelectionRange(end, end);
                    input.focus();
                }
            }
        },

        render: function() {
            this.options.name = this.el?.closest('.fn-lookup')?.dataset?.validationType;
            this.$el.html(this.tmpl(this.options.template, this.options));
            this.$el.removeClass('fn-validate');

            this.attachWidget(this.$el.find(this.options.elSelector).autocomplete({
                className: 'customElement__autocomplete',
                isCustomElement: true,
                search: this.search.bind(this),
                onSelect: this.handleSelectItem.bind(this),
                showAll: this.setDropDownResult.bind(this),
                minLength: 1,
                visibleRows: 5,
                collapseOnSelect: false,
                collapseOnScroll: false,
                template: 'customEmailItem'
            }));

            return this;
        }
    });

});
